import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getArtists = () => api.get('/artists').then(r => r.data);
export const getArtist = (slug) => api.get(`/artists/${slug}`).then(r => r.data);
export const getArtworks = (params = {}) => api.get('/artworks', { params }).then(r => r.data);
export const getArtwork = (slug) => api.get(`/artworks/${slug}`).then(r => r.data);
export const getExhibitions = (params = {}) => api.get('/exhibitions', { params }).then(r => r.data);
export const getExhibition = (slug) => api.get(`/exhibitions/${slug}`).then(r => r.data);
export const getJournal = () => api.get('/journal').then(r => r.data);
export const getJournalPost = (slug) => api.get(`/journal/${slug}`).then(r => r.data);

export const getVideos = (params) => api.get('/videos', { params }).then(r => r.data);
export const getVideo = (slug) => api.get(`/videos/${slug}`).then(r => r.data);
/** Return 'fr' if the visitor is on a /fr/* URL, otherwise 'en'. Used to
 *  stamp submissions with the visitor's active language for gallery
 *  internal notifications and future locale-aware email routing. */
function _currentLocale() {
    try {
        const p = typeof window !== 'undefined' ? window.location.pathname : '';
        return (p === '/fr' || p.startsWith('/fr/')) ? 'fr' : 'en';
    } catch (_) { return 'en'; }
}

export const postEnquiry = (data) =>
    api.post('/enquiries', { ...data, locale: data.locale || _currentLocale() }).then(r => r.data);
export const postNewsletter = (email) =>
    api.post('/newsletter', { email, locale: _currentLocale() }).then(r => r.data);
export const createCheckout = (data) => api.post('/checkout/session', data).then(r => r.data);
export const getCheckoutStatus = (sid) => api.get(`/checkout/status/${sid}`).then(r => r.data);
export const getSiteSettings = () => api.get('/settings').then(r => r.data);
export const updateSiteSettings = (data) => api.put('/admin/settings', data).then(r => r.data);
export const resetSiteSettings = () => api.post('/admin/settings/reset').then(r => r.data);

